import React from 'react';
import { Box, Typography, Chip, Button, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { contrastRatio, contrastTextColor } from '../../theme/contrast';
import { deriveAccentColor } from '../../theme/colorUtils';

function StyleValidator({ settings, onApply }) {
  const theme = useTheme();
  const bg = theme.palette.background.paper;
  const primary = settings.brandColor || '#6D55F7';
  const accent = settings.accentColor || '#9DE94B';

  const primaryBgContrast = contrastRatio(primary, bg);
  const accentBgContrast = contrastRatio(accent, bg);
  const primaryTextContrast = contrastRatio(primary, contrastTextColor(primary));

  const issues = [];
  if (primaryBgContrast < 3) issues.push('Kolor podstawowy jest zbyt bliski tła.');
  if (accentBgContrast < 3) issues.push('Kolor akcentu jest zbyt bliski tła.');
  if (!settings.fontFamily || settings.fontFamily.includes('system-ui')) issues.push('Czcionka nie została spersonalizowana.');
  if (!settings.logo) issues.push('Brak logo organizacji.');

  const handleAutoFix = () => {
    const suggestedAccent = settings.accentColor && settings.accentColor !== '#9DE94B'
      ? settings.accentColor
      : deriveAccentColor(primary);
    onApply({
      accentColor: suggestedAccent,
      fontFamily: settings.fontFamily || 'Inter, system-ui, sans-serif',
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, borderRadius: `${theme.tokens?.primitive?.radius?.card ?? 20}px`, border: `1px solid ${theme.palette.divider}`, bgcolor: 'background.paper' }}>
      <Typography variant="subtitle2" fontWeight={700}>Walidator stylu</Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip label={`Kontrast koloru podstawowego z tłem: ${primaryBgContrast.toFixed(2)}`} color={primaryBgContrast >= 4.5 ? 'success' : primaryBgContrast >= 3 ? 'warning' : 'error'} size="small" />
        <Chip label={`Kontrast akcentu z tłem: ${accentBgContrast.toFixed(2)}`} color={accentBgContrast >= 4.5 ? 'success' : accentBgContrast >= 3 ? 'warning' : 'error'} size="small" />
        <Chip label={`Tekst na kolorze podstawowym: ${primaryTextContrast.toFixed(2)}`} color={primaryTextContrast >= 4.5 ? 'success' : 'warning'} size="small" />
      </Box>

      {issues.length > 0 ? (
        <Alert severity="warning" sx={{ alignItems: 'flex-start' }}>
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {issues.map((issue, i) => (
              <li key={i}><Typography variant="body2">{issue}</Typography></li>
            ))}
          </Box>
        </Alert>
      ) : (
        <Alert severity="success">Styl wygląda dobrze i jest czytelny.</Alert>
      )}

      <Button
        variant="outlined"
        size="small"
        startIcon={<AutoFixHighIcon />}
        onClick={handleAutoFix}
        sx={{ alignSelf: 'flex-start', borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px` }}
      >
        Auto-dopasuj kolory i czcionkę
      </Button>
    </Box>
  );
}

export default StyleValidator;
